import { useEffect, useState } from "react";
import { PixelPoint } from "../../math/PixelPoint";
import { precacheContours } from "../workers/precacheContours";
import { viewportStateFromViewState } from "../../math/_common";
const pigments = [
    { name: 'Grass', color: [184, 201, 110] },
    { name: 'Forest', color: [99, 153, 53] },
    { name: 'Deep Forest', color: [53, 84, 18] },
    { name: 'Mountains', color: [94, 78, 14] },
    { name: 'Water', color: [112, 185, 211] },
    { name: 'Ocean', color: [23, 105, 170] },
];
export const useDeckGLViewState = () => {
    const [viewState, setViewState] = useState({
        target: [0, 0],
        zoom: 0,
        minZoom: -4,
        maxZoom: 2,
    });
    const [interactionState, setInteractionState] = useState();
    const [editorState, setEditorState] = useState({
        brushSize: 1,
        debug: false,
        maxBrushSize: 5,
        pigment: pigments[0],
        pigments,
    });
    const [viewportState, setViewportState] = useState(() => viewportStateFromViewState(viewState));
    useEffect(() => setViewportState(viewportStateFromViewState(viewState)), [viewState.zoom, viewState.width, viewState.height, viewState.target]);
    const [precacheOperation, setPrecacheOperation] = useState();
    useEffect(() => {
        if (!viewportState)
            return;
        const { viewportLeft, viewportTop, viewportRight, viewportBottom } = viewportState;
        const topLeftPx = PixelPoint.create(viewportLeft, viewportTop);
        const bottomRightPx = PixelPoint.create(viewportRight, viewportBottom);
        precacheOperation?.cancel();
        setPrecacheOperation(precacheContours(topLeftPx, bottomRightPx, viewState.zoom));
    }, [editorState.brushSize, viewportState]);
    const updateEditorState = (partial) => setEditorState({ ...editorState, ...partial });
    const zoom = typeof viewState.zoom === 'number' ? viewState.zoom : 0;
    return {
        editorState,
        interactionState,
        viewportState,
        viewState: { ...viewState, zoom },
        setEditorState,
        setInteractionState,
        setViewState,
        updateEditorState,
    };
};
//# sourceMappingURL=deckGLViewState.js.map